export const deleteValue = (arr, id) => {
  let idx = arr.findIndex((o) => o?.user?.id == id);
  if (idx >= 0) arr.splice(idx, 1);
  return arr;
};
